import type { FieldReadFunction } from '@apollo/client'

const read: FieldReadFunction<MortgageStatus | undefined> = (_, { readField, args, toReference }) => {
  const documentRef = toReference({ __typename: 'DocumentEntity', document_id: args?.id })
  const mortgageId = readField<string>('rendered_mortgage_ids', documentRef)?.[0]
  const mortgageRef = toReference(`Mortgage:${mortgageId}`)

  return readField('status', mortgageRef)
}

export default { read }
